import {  useState } from "react";
import axios from "axios";
import MaterialTable from "material-table";
import { Paper } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import _ from "lodash";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { autoTable } from 'jspdf-autotable'


import { getTrans as t } from "../../Localization/translations";
import authHeader from "../../services/auth-header";
import { API } from "../../backend";

function TransactionTypes() {
  const [data, setData] = useState([]);
  const [permissionss,setPermission] = useState(localStorage.getItem('permissions'))
  const permissionsArray = permissionss.split(',');
  const ENABLED = {
    Y: "Yes",
    N: "No",
  };

  const fetchAllDataForExport = async () => {
    let allData = [];
    let currentPage = 0;
    const pageSize = 10;

    while (true) {
      const query = {
        pageSize,
        page: currentPage,
        search: '',
      };

      let url = API + "accounting/transactiontypesview/?";
      url += "per_page=" + query.pageSize;
      url += "&page=" + (query.page + 1);

      try {
        const response = await fetch(url, { headers: authHeader() });
        const result = await response.json();

        if (result.data.length === 0) {
          break;
        }

        allData = allData.concat(result.data);
        currentPage++;
      } catch (error) {
        console.error("Error fetching data:", error);
        break;
      }
    }

    return allData;
  };

  return (
    <div className="container-fluid py-4 pt-2">
      <div className="row py-2 mt-2">
        <ToastContainer />
        <div className="col-md-12">
          <div className=" mb-0">
            <div className="header pb-0">
              <div className="d-lg-flex">
                {/* <div>
                  <h5 className="mb-0">{t("Transactions")}</h5>
                </div> */}
              </div>
            </div>
            <div className="body">
              <div className="p-0">
                <MaterialTable
                  style={{
                    padding: "0.5rem 0.5rem",
                    backgroundColor: "var(--bs-table-bg)",
                    borderBottomWidth: "1px",
                    boxShadow: "inset 0 0 0 9999px var(--bs-table-accent-bg)",
                  }}
                  title="Transactions"
                  columns={[
                    {
                      title: `${t("Transaction Type")}`,
                      field: "transaction_type",
                      editable: "never",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Transaction Type")}</div>
                          <div>{rowData.transaction_type}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Description")}`,
                      field: "description",
                      editable: "never",
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Description")}</div>
                          <div>{rowData.description}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Approval")}`,
                      field: "approval",
                      lookup: ENABLED,
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Approval")}</div>
                          <div>{ENABLED[rowData.approval]}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                    {
                      title: `${t("Accounting")}`,
                      field: "enabled",
                      lookup: ENABLED,
                      render: (rowData) => (
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("Enabled")}</div>
                          <div>{ENABLED[rowData.enabled]}</div>
                        </>
                      ),
                      headerStyle: {
                        verticalAlign: "inherit",
                        fontWeight: "bold",
                        textAlign: "left",
                      },
                      cellStyle: {
                        textAlign: "left",
                        fontSize: 12,
                      },
                    },
                  ]}
                  data={(query) =>
                    new Promise((resolve, reject) => {
                      const { orderBy, orderDirection } = query;

                      let url = API + "accounting/transactiontypesview/?";
                      url += "per_page=" + query.pageSize;
                      url += "&page=" + (query.page + 1);
                      if (orderBy) {
                        url += `&orderBy=${orderBy.field}`;
                        url += `&orderDirection=${orderDirection}`;
                        }
                      fetch(url, { headers: authHeader() })
                        .then((response) => response.json())
                        .then((result) => {
                          resolve({
                            data:
                              query.orderBy && query.orderDirection
                                ? _.orderBy(
                                    result.data,
                                    [query.orderBy.field],
                                    [query.orderDirection]
                                  )
                                : result.data,
                            page: result.page - 1,
                            totalCount: result.total,
                          });
                        });
                    })
                  }
                  editable={{
                    onRowUpdate:permissionss &&  permissionsArray.includes('change_transactiontypes')===true ? (newData, oldData) =>
                      new Promise((resolve, reject) => {
                        const updatedStatusData = { enabled: newData.enabled, approval: newData.approval };
                        axios
                          .post(
                            API + `accounting/transactiontype-edit/${oldData.id}/`,
                            updatedStatusData,
                            { headers: authHeader() }
                          )
                          .then((response) => {
                            const dataUpdate = [...data];
                            const index = oldData.tableData.id;
                            dataUpdate[index] = {
                              ...oldData,
                              ...updatedStatusData,
                            };
                            setData([...dataUpdate]);
                            resolve();
                          })
                          .catch((error) => {
                            reject();
                          });
                      }):"",
                  }}
                  components={{
                    Container: (props) => (
                      <div id="Payment">
                        <Paper {...props} />
                      </div>
                    ),
                  }}
                  options={{
                    headerStyle: {
                      backgroundColor: "white",
									color: "#245C7F",
                      fontSize: 12,
                    },
                    rowStyle: (rowData, index) => {
                      if (index % 2) {
                        return { backgroundColor: "#fff" };
                      }
                    },
                    sorting: true,
                    search: false,
                    toolbar: true,
                    paging: true,
                    exportAllData: true,
                    exportButton: true,
                    exportFileName: "Transactions",
                    pageSize: 10, 
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [10, 15, 20, 50],
                    paginationType: "stepped",
                    showFirstLastPageButtons: false,
                    actionsColumnIndex: -1,
                    exportCsv: async (columns, data) => {
                      try {
                        const allData = await fetchAllDataForExport();
                        const title = "Transactions Report";
                        const currentDate = new Date().toLocaleDateString();
                        const csvContentWithInfo = `${title}\n Date: ${currentDate}\n \n\n`;
                        const csvColumns = columns.map(columnDef => columnDef.title);

                        const csvData = allData.map(rowData => {
                          const rowDataArray = columns.map(columnDef => {
                            return rowData[columnDef.field] || '';
                          });
                          return rowDataArray;
                        });

                        const csvRows = [csvColumns, ...csvData];

                        const csvContent = `${csvContentWithInfo}${csvRows.map(row => row.join(',')).join('\n')}`;

                        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = 'Transactions.csv';
                        link.style.display = 'none';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      } catch (error) {
                        console.error("Error exporting CSV:", error);
                      }
                    },

                    exportPdf: async (columns, data) => {
                      const allData = await fetchAllDataForExport();
                      
                      // if (allData.length === 0) {
                      //   console.error("No data found for PDF export");
                      //   return;
                      // }
                      const doc = new jsPDF();
                      doc.setFont("helvetica", "bold");
                      doc.setFontSize(16);

                      const title = "Transactions Report";
                      doc.text(title, 14, 10);

                      doc.setFontSize(12);
                      doc.setFont("helvetica", "normal");
                      const currentDate = new Date().toLocaleDateString();
                      doc.text(`Date: ${currentDate}`, 14, 15);
                      const space = 22;
                      const tableStartY = 5 + space;
                      const columnTitles = columns.map(columnDef => columnDef.title);
                      const pdfData = allData.map(rowData =>
                        columns.map(columnDef => {
                          return rowData[columnDef.field];
                        })
                      );
                      const tableData = [columnTitles, ...pdfData];

                      // doc.autoTable({
                      autoTable(doc,{
                        head: [tableData[0]], 
                        body: tableData.slice(1), 
                        startY: tableStartY,
                      });

                      doc.save(`Transactions.pdf`);
                    },
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TransactionTypes;
